/**
 * This function handles all incomming failed request.
 *
 * @param {Error} error - A axios error object.
 */
export default function (error) {
  const originalStackTrace = error.config?.errorContext?.stack
  if (originalStackTrace) error.stack = `${error.stack}\n${originalStackTrace}`

  Promise.reject(error)
}
